const Main_Research_cse=[
    { 'id' : '1',
       'program':'Computer Science Engineering ',
       'pdf':'/csedept'
   },
   

]

const Main_Research_ece=[
    { 'id' : '2',
    'program':'Electronics & Communication Engineering ',
    'pdf':'/ecedept/ece-research'
},

]

const Main_Research_eee=[
    { 'id' : '3',
    'program':'Electrical & Electronics Engineering',
    'pdf':'eeedept/eee-research'
},

]

const Main_Research_mech=[
    { 'id' : '4',
    'program':'Mechanical Engineering ',
    'pdf':'/mechdept/mech-phd'
},
]

const Main_Research_civil=[
    { 'id' : '5',
    'program':'Civil Engineering ',
    'pdf':'/civildept/civil-research'
},
]
const Research_Promotion_Policy=[
    { 'id' : '6',
    'program':'Research Promotion Policy ',
    'pdf':'/ResearchPromotionPolicy.pdf'
},
]


export{
    Main_Research_cse,
    Main_Research_ece,
    Main_Research_eee,
    Main_Research_mech,
    Main_Research_civil,
    Research_Promotion_Policy,
}
